import React, { Component } from 'react';

class GameOverDisplay extends Component {
  constructor(props) {
    super(props);

    this.renderClassName = this.renderClassName.bind(this);
  }

  render() {
    return (
      <div className={this.renderClassName(this.props.score)}/>
    );
  }

  renderClassName(param) {
    if (param < 3) {
      return 'game__game-overdisp00';
    } else if (param >= 3 && param < 13) {
      let x = Math.floor(Math.random() * ((5-1)+1) + 1)
      return 'game__game-overdisp0'+x;
    } else if (param >= 13 && param < 15) {
      let x = Math.floor(Math.random() * ((7-6)+1) + 6)
      return 'game__game-overdisp0'+x;
    } else if (param >= 15) {
      return 'game__game-overdisp08'
    } else {
      return 'shit'
    }
  }
}

  export default GameOverDisplay;



// WEBPACK FOOTER //
// ./src/components/GameOverDisplay.js